import {Component} from '@angular/core';
import {ModalBaseComponent} from '~shared/ng/components/dialog/base/modal-base.component';
import {NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {ValidationCssDirective} from '~shared/ng/modules/validation/directives/validation/validation-css.directive';
import {ValidationErrorComponent} from '~shared/ng/modules/validation/components/validation/validation-error.component';
import {provideValidationWithRules, ValidationModule} from '~shared/ng/modules/validation/validation.module';
import {formDisabledSourceProvider} from '~shared/ng/modules/validation/directives/utils/form-disabled.directive';
import {EmailRule, RequiredRule} from '~shared/ng/modules/validation/rules/rules';
import {ValidationSubmitEvent} from '~shared/ng/modules/validation/directives/check/validation-check-base.directive';
import {SpriteIconComponent} from '../../../../../portal/src/app/shared/components/sprite-icon/sprite-icon.component';
import {BaseAuthForm} from '~shared/types/authentication.types';


@Component({
    standalone: true,
    selector: 'app-basic-auth-dialog',
    templateUrl: './basic-auth-dialog.component.html',
    styleUrl: './basic-auth-dialog.component.scss',
    viewProviders: [
        formDisabledSourceProvider,
    ],
    providers: [
        provideValidationWithRules({
            authForm: {
                basicAuthEmail: [new RequiredRule(), new EmailRule()],
                basicAuthPassword: [new RequiredRule()],
            },
        })
    ],
    imports: [
        ValidationModule,
        FormsModule,
        ValidationErrorComponent,
        NgIf,
        RouterLink,
        TranslateModule,
        ValidationCssDirective,
        SpriteIconComponent
    ]
})
export class BasicAuthDialogComponent extends ModalBaseComponent<{}, BaseAuthForm> {
    public showPassword: boolean = false;

    public submit($event: ValidationSubmitEvent<BaseAuthForm>): void {
        this.close($event.formData);
    }
}
